import React, { useState } from 'react'
import api from '../../../../middleware/api';
import { useCapsuleConfigurator } from '../../../../context/CapsuleConfiguratorContext';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';

const PreTestSelector = ({ handleChange, value, property, disabled }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [localValue, setLocalValue] = useState(value || false);

    const labels = {
        mentalDisturbance: 'Voile Mental',
        emotionalDisturbance: 'Voile Émotionnel',
        maintainSymptoms: 'Voile Énergétique',
        organicInversion: 'Inversion Organique',
        emotionalInversion: 'Inversion Émotionnelle',
    }

    const { setData: updateCustomerData } = useOutletContext()
    const { defaultCapsule, selectedConfigurationId, setCapsuleConfiguration,synchronizeConfigurations} = useCapsuleConfigurator()
    const onChange = async (e) => {
        if (disabled) return;

        setIsLoading(true);

        // Immediately update local state for instant UI feedback
        const newValue = e.target.checked;
        setLocalValue(newValue);

        // Also update parent state through handleChange for immediate UI reflection
        handleChange(newValue)(e);

        // Also update the context state directly
        setCapsuleConfiguration((prev) => ({
            ...prev,
            [property]: newValue
        }));

        const isNewCapsule = defaultCapsule.configurations.length === 0
        try {
            const response = await api.patch(`/capsules/configurations/update/property`, {
                configurationId: selectedConfigurationId,
                property: property,
                newValue: newValue
            })
            if (response.status === 200) {
                // Update customer data
                if (response.data.configurations.length > 1) {
                    synchronizeConfigurations(response.data.configurations)
                } else {
                    updateCustomerData((prev) => {
                        return {
                            ...prev,
                            capsules: prev.capsules.map(capsule => {
                                if (capsule.id === defaultCapsule.id) {
                                    return {
                                        ...capsule,
                                        configurations: isNewCapsule ? [response.data.configurations[0]] : capsule.configurations.map(configuration => {
                                            if (configuration.id === selectedConfigurationId) {
                                                configuration.configuration[property] = response.data.configurations[0].configuration[property]
                                            }
                                            return configuration
                                        })
                                    }
                                }
                                return capsule
                            })
                        }
                    })
                }
            } else {
                // Revert the local state if the request failed
                setLocalValue(!newValue);
                toast.error('Erreur lors de la mise à jour de la dilution');
            }
        } catch (error) {
            // Revert the local state if the request failed
            setLocalValue(!newValue);
            toast.error('Erreur lors de la mise à jour du pré-test');
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Update the local value when the prop changes
    React.useEffect(() => {
        setLocalValue(value);
    }, [value]);
    return (
        <label className={`hover:scale-95 badge badge-xs h-7 ${localValue ? 'badge-primary text-white ' : 'badge-primary badge-outline border-solid'} border shadow-md rounded-md px-2 label cursor-pointer flex gap-x-3 ${disabled ? 'opacity-60 pointer-events-none' : ''} ${isLoading ? 'opacity-70' : ''}`}>
            <span className={`label-text text-xs ${localValue ? 'text-white ' : ''} `}>{labels[property]}</span>
            {isLoading ? (
                <span className="loading loading-spinner loading-xs text-primary"></span>
            ) : (
                <input onChange={onChange} type="checkbox" className={`toggle toggle-xs ${localValue ? 'toggle-primary ' : 'toggle-disabled'} `} checked={localValue} name={property} disabled={(disabled && !value) || isLoading} />
            )}
        </label>)
}

export default PreTestSelector
